import React from "react";
import { IMAGE_URL } from "config/index";

function ImageElement({
  previewSource = "",
  imageFor = "user",
  source,
  alt = "image",
  ...rest
}) {
  const imagePath = {
    user: IMAGE_URL,
  };
  return (
    <>
      {previewSource ? (
        <img
          src={previewSource}
          alt={alt}
          {...rest}
          onError={(e) => {
            e.target.src = `${process.env.REACT_APP_API_V1}${process.env.REACT_APP_DEFAULT_IMAGE}`;
          }}
          loading="lazy"
        />
      ) : (
        <img
          src={`${imagePath[imageFor]}/${source}`}
          alt={alt}
          {...rest}
          onError={(e) => {
            e.target.src = `${process.env.REACT_APP_API_V1}${process.env.REACT_APP_DEFAULT_IMAGE}`;
          }}
          loading="lazy"
        />
      )}
    </>
  );
}

export default ImageElement;
